import * as React from 'react';

export function useStableCallback<T extends (...args: never[]) => unknown>(
  fn: T,
): T {
  const ref = React.useRef(fn);
  React.useLayoutEffect(() => {
    ref.current = fn;
  });
  return React.useCallback((...args: Parameters<T>) => {
    return ref.current(...args);
  }, []) as T;
}
